import { useContext } from 'react';

import { ThemeContext } from '@/styled/themes/ThemeProvider/ThemeContext';

export const useTheme = () => useContext(ThemeContext);
